import { g as r } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCloudSunRain",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, m = ["aria-label", "data-qa", "aria-hidden"], p = ["clip-path"], f = ["id"];
function h(e, t, n, _, v, i) {
  return d(), o("svg", {
    "aria-label": n.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--cloud-sun-rain"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Cloud Sun Rain",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M6 .5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V1A.5.5 0 0 1 6 .5ZM2.111 2.111a.5.5 0 0 1 .708 0l.705.705a.5.5 0 1 1-.708.708l-.705-.705a.5.5 0 0 1 0-.708ZM9.5 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm.389-3.889a.5.5 0 0 1 0 .708l-.705.705a.5.5 0 1 1-.708-.708l.705-.705a.5.5 0 0 1 .708 0ZM4.764 3.826a2.5 2.5 0 0 1 3.703 2.58.5.5 0 1 1-.987-.162 1.5 1.5 0 0 0-2.222-1.548.5.5 0 0 1-.494-.87ZM3.98 6.558A2 2 0 0 0 1.9 9.7a.5.5 0 0 1-.8.6 2.999 2.999 0 1 1 5.23-2.8h.17a2 2 0 0 1 1.332 3.492.5.5 0 0 1-.666-.746l.041-.039A1 1 0 0 0 6.5 8.5h-.55a.5.5 0 0 1-.49-.4 2 2 0 0 0-1.48-1.542Z" }, null, -1),
      a("path", { d: "M5.5 9.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5Zm-2-.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5Z" }, null, -1)
    ])], 8, p),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, f)
    ])
  ], 10, m);
}
const M = /* @__PURE__ */ u(c, [["render", h]]);
export {
  M as default
};
//# sourceMappingURL=cloud-sun-rain.js.map
